import { Pagination } from "antd";
import * as React from "react";

const Basic = ({
  paginationStyle,
  containerStyle,
  total,
  count,
  current,
  disabled = false,
  pageSize = 10,
  size,
  showSizeChanger = false,
  onChange,
  hideOnSinglePage = false,
  position,
  responsive = true,
  ...props
}) => {
  return (
    <div style={containerStyle}>
      <Pagination
        defaultCurrent={1}
        total={total}
        current={current}
        disabled={disabled}
        pageSize={pageSize}
        size={size}
        showSizeChanger={showSizeChanger}
        onChange={onChange}
        hideOnSinglePage={hideOnSinglePage}
        style={paginationStyle}
        responsive={responsive}
        position={position}
        {...props}
      />
    </div>
  );
};

export default Basic;
